var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarningRound = function SvgWarningRound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Warning Round",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-33.000000, -385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warning",
    transform: "translate(33.000000, 385.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,5.49375 L19.53,18.50375 L4.47,18.50375 L12,5.49375 L12,5.49375 Z M2.74,17.50375 C1.97,18.83375 2.93,20.50375 4.47,20.50375 L19.53,20.50375 C21.07,20.50375 22.03,18.83375 21.26,17.50375 L13.73,4.49375 C12.96,3.16375 11.04,3.16375 10.27,4.49375 L2.74,17.50375 Z M11,10.50375 L11,12.50375 C11,13.05375 11.45,13.50375 12,13.50375 C12.55,13.50375 13,13.05375 13,12.50375 L13,10.50375 C13,9.95375 12.55,9.50375 12,9.50375 C11.45,9.50375 11,9.95375 11,10.50375 Z M11,15.50375 L13,15.50375 L13,17.50375 L11,17.50375 L11,15.50375 Z",
    id: "Icons/24/Warning"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarningRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning-round.8214c69c6b080f85cee0572a7bce3d27.svg";